
<template>

  <v-flex d-flex align-center class="px-2">
    <v-flex xs3>
      <v-flex d-flex align-center>
        <h3>{{content.title}} :</h3>
      </v-flex>
    </v-flex>
    <v-flex xs9 class="text-xs-right">
      <v-flex d-flex align-center class="text-xs-right">
        <v-flex grow>
          <v-select class="text-xs-right" :items="content.devmodes.slice(0, devmodes)" v-model="edit" @change="modify()" :menu-props="{ maxHeight: '500px' }"></v-select>
        </v-flex>
        <div style="flex: 0!important;">
          <v-btn flat fab small :color="icons[devmode].color" :loading="loading">
            <v-icon>{{icons[devmode].icon}}</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-flex>
  </v-flex>

</template>

<script>

import { mapGetters } from 'vuex'
export default {
    props: ['locale', 'devmodes'],
    data() {
        return {
          edit: null,
          loading: null,

          icons: [{
              icon: "timer",
              color: "blue darken-4"
          }, {
              icon: "wb_sunny",
              color: "yellow darken-2"
          }, {
              icon: "ac_unit",
              color: "blue"
          }, {
              icon: "opacity",
              color: "cyan lighten-3"
          }, {
              icon: "format_color_reset",
              color: "cyan lighten-3"
          }, {
              icon: "wb_incandescent",
              color: "yellow darken-1"
          }, {
              icon: "wb_incandescent",
              color: "grey lighten-1"
          }],
        }
    },
    created() {
      this.setLang();
      this.setEdit();
      //
      // EventBus.$on('updateItemsBus', data => {
      //   this.loading = false;
      //   this.setEdit();
      // });
    },
    computed: {
       ...mapGetters(['devices/device']),
      devmode: function (getter) {
        this.loading = null
        return getter['devices/device'](this.$route.params.slug).data.devmode;
      }
    },
    // watch: {
    //   devmode(){
    //     this.setEdit();
    //   }
    // },
    methods: {
        setEdit(){
          this.edit = this.content.devmodes[this.devmode];
        },
        modify(){
          this.loading = true;
          let data = {
            slug: this.$route.params.slug,
            modify:{
              parameter: 'devmode',
              value: this.edit,
            }
          }
          this.$store.dispatch('devices/modifyDevice', data);
          // console.log(data);
          // this.$emit('modifyItemEvent', data);
        },

        setLang() {
          if (this.locale == "en") {
              this.content = {
                title: 'Mode',
                // devmodes: ['Timer', 'Heating', 'Cooling', 'Increasing humidity', 'Decreasing humidity', 'Turning light on', 'Turning light off'],
                devmodes: [
                  {
                    text: 'Timer',
                    value: 0
                  },
                  {
                    text: 'Heating',
                    value: 1
                  },
                  {
                    text: 'Cooling',
                    value: 2
                  },
                  {
                    text: 'Increasing humidity',
                    value: 3
                  },
                  {
                    text: 'Decreasing humidity',
                    value: 4
                  },
                  {
                    text: 'Turning light on',
                    value: 5
                  },
                  {
                    text: 'Turning light off',
                    value: 6
                  },
                ],
              };
          } else if (this.locale == "he") {
              this.content = {
                title: 'מצב פעולה',
                // devmodes: ['טיימר', 'חימום', 'קירור', 'הגברת לחות', 'הורדת לחות', 'הגברת אור', 'הורדת אור'],
                devmodes: [
                  {
                    text: 'טיימר',
                    value: 0
                  },
                  {
                    text: 'חימום',
                    value: 1
                  },
                  {
                    text: 'קירור',
                    value: 2
                  },
                  {
                    text: 'הגברת לחות',
                    value: 3
                  },
                  {
                    text: 'הורדת לחות',
                    value: 4
                  },
                  {
                    text: 'הגברת אור',
                    value: 5
                  },
                  {
                    text: 'הורדת אור',
                    value: 6
                  },
                ],
              };
          }
        },
    }
}

</script>
